import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/red-alert-icon.svg'


export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_AlertDialog = _resolveComponent("AlertDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_q_btn, {
      class: "badge-danger btn tw-document-trigger-btn",
      onClick: _ctx.toggleShowControls,
      floating: ""
    }, {
      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
        _createElementVNode("img", {
          src: _imports_0,
          alt: "Gestion Alert"
        }, null, -1)
      ]))]),
      _: 1
    }, 8, ["onClick"]),
    (_ctx.toggleShow)
      ? (_openBlock(), _createBlock(_component_AlertDialog, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64))
}